import {csv as d3csv, json as d3json} from 'd3-request';
import * as topojson from 'topojson-client';
import * as _ from 'underscore';

// import * as App from '../App/App';
import Dispatch from '../Dispatch/Dispatch';

// console.log('model module', Dispatch.dispatch);

function processData(csv) {
	let ret = _.map(csv, d => {
		return {
			country: d['Country (for map)'],
			region: d['Region (for map)'],
			regionLabel: d['Region'],
			burden: +d['ETEC_Shigella Burden (deaths/100,000 children)']
		}
	})
	return ret
}

function makeLookup(csv) {
	let lu = {};
	_.each(csv, d => {
		if(!_.has(lu, d.country))
			lu[d.country] = {};

		lu[d.country][d.region] = d
	})
	return lu
}


var api = {
	regionsJson: null, // Africa subset regions
	countryJson: null,  // outline of Africa countries
	data: null,
	dataLU: null,

	load: function() {

		d3json('data/africa-subset.topo.json', function(err, json) {
			api.regionsJson = topojson.feature(json, json.objects['merged-from-qgis'])
			Dispatch.dispatch.call('regionBoundariesReady')
		});

		d3json('data/africa.topo.json', function(err, json) {
			api.countryJson = topojson.feature(json, json.objects['africa'])
			Dispatch.dispatch.call('countryBoundariesReady')
		});

		d3csv('data/data.csv?1', function(err, csv) {
			api.data = processData(csv)
			api.dataLU = makeLookup(api.data)

			Dispatch.dispatch.call('dataReady')
		});

	}
};

export default api;




/** WEBPACK FOOTER **
 ** ./src/Model/Model.js
 **/